import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { OwnPartsPopupComponent } from '../own-parts-popup/own-parts-popup.component';
import { ViewportScroller } from '@angular/common';
import { KbExportToXlsxService } from 'src/app/services/feature/ExportCsv/kb-export-csv.service';
import { KbMyOwnPartNumbersService } from 'src/app/services/feature/MyOwnPartNumbers/kb-my-own-part-numbers.service';

@Component({
  selector: 'app-kb-my-own-partnumbers',
  templateUrl: './kb-my-own-partnumbers.component.html',
  styleUrls: ['./kb-my-own-partnumbers.component.scss'],
  standalone: false
})
export class KbMyOwnPartnumbersComponent {
  customerId$: Observable<any> = this.service.getApi();
  private destroy$ = new Subject<void>();
  translationBlocker: boolean = false;
  isMobile: boolean = false;
  baseUrl;
  mediaUrl;
  sub = new Subscription();
  dataArray: any[];
  pageSource: string = 'myOwnPartNumbers';
  finaliseddata: string = '';
  error: boolean = false;
  orderType: string;
  errorArray: any;
  isCustomerSelected: boolean = false;
  popupData: any;
  constructor(
    private service: KbMyOwnPartNumbersService,
    private breakpointObserver: BreakpointObserver,
    private Export: KbExportToXlsxService,
    private globalmsgService: GlobalMessageService,
    private cdr: ChangeDetectorRef,
    private matdialog: MatDialog,
    private translator: TranslationService,
    private scroller: ViewportScroller
  ) {
    this.sub.add(
      this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
        this.isMobile = result.matches;
      })
    );
  }
  checkcustIdSelected(event: Event) {
    this.error = false;
    if (this.finaliseddata.length == 0) {
      event.preventDefault();
      this.isCustomerSelected = true;
      this.cdr.detectChanges();
    }
  }
  onFileSelected(event: any): void {
    const selectedFile = event.files[0];
    if (selectedFile) {
      this.error = false;
      const formData = new FormData();
      formData.append('myPartFile', selectedFile);
      this.service
        .postApiForUploadFile(formData, this.finaliseddata)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (x: any) => {
            let popupData;
            this.translationBlocker = true;
            if ((x.status == 'SUCCESS')) {
              this.translator
                .translate(x.message)
                .pipe(filter(() => this.translationBlocker), takeUntil(this.destroy$))
                .subscribe((res: string) => {
                  const updatedRes = res
                    .replace('{0}', x.errorValue1)
                    .replace('{3}', x.errorValue2)
                    .replace('{1}', x.errorIntValue1)
                    .replace('{2}', x.errorIntValue2);
                  const translatedData = updatedRes.split('###');
                  popupData = {
                    line1: translatedData[0],
                    line2: translatedData[1],
                    line3: translatedData[2],
                    line4: translatedData[3],
                  };
                  const dialogRef = this.matdialog.open(OwnPartsPopupComponent, {
                    data: popupData,
                  });
                  dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((data) => {
                    if (data) {
                      this.service
                        .secondPostApiForUploadFile(formData, this.finaliseddata)
                        .pipe(takeUntil(this.destroy$))
                        .subscribe((resData: any) => {
                          if (resData?.fileUploadErrorMessages?.length > 0) {
                            this.errorArray = resData.fileUploadErrorMessages;
                            this.error = true;
                            event.value = '';
                            this.scroller.scrollToPosition([0, 100]);
                          } else if (resData?.message?.status == 'SUCCESS') {
                            this.globalmsgService.add(
                              { key: resData.message.message },
                              GlobalMessageType.MSG_TYPE_INFO
                            );
                          }

                          this.cdr.detectChanges();
                        });
                    } else {
                      event.value = '';
                    }
                  });
                });
            }
            this.translationBlocker = false;
          },
          (error) => {
            event.value = '';
          }
        );
    }
  }
  downloader() {
    this.service.postApiForDownloadFile(JSON.parse(JSON.stringify(this.finaliseddata))).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      if (res) {
        this.Export.exportwithBoldHeader(res.data, "My_own_part_numbers.xlsx");
      }
    });
  }
  onChildValue(value: any) {
    this.isCustomerSelected = false;
    this.dataArray = value;
    this.finaliseddata = this.getSelectedUids();
  }
  getSelectedUids(): string {
    return this.dataArray
      .filter((item) => item.selected)
      .map((item) => `unitcodes=${item.uid}`)
      .join('&');
  }
 
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.sub.unsubscribe();
  }
}
